type Order = {
  Lot: string | number;
  OrderQuantity: string | number;
  MaterialUnitOfMeasure: string;
};

type Volume = {
  VolumeOrderQuantity: string | number;
  MaterialUnitOfMeasure: string;
};

type Suggestion = {
  Lot: string | number;
  LotRoudingUnit?: string;
  Quantity: string | number;
  MaterialUnitOfMeasure: string;
};

// -------------------- Summarizer --------------------

export const Summarizer = {
  orders: {
    lots: (orders: Order[]) => {
      const normalized = orders.map(o => ({
        lot: o.Lot
      }));
      return summarizeLotsGeneric(normalized);
    },
    quantities: (orders: Order[]) => {
      const normalized = orders.map(o => ({
        quantity: o.OrderQuantity,
        unit: o.MaterialUnitOfMeasure
      }));
      return summarizeQuantitiesGeneric(normalized);
    }
  },

  volumes: {
    quantities: (volumes: Volume[]) => {
      const normalized = volumes.map(v => ({
        quantity: v.VolumeOrderQuantity,
        unit: v.MaterialUnitOfMeasure
      }));
      return summarizeQuantitiesGeneric(normalized);
    }
    // volumes não têm lots
  },

  suggestions: {
    lots: (suggestions: Suggestion[]) => {
      const normalized = suggestions.map(s => ({
        lot: s.Lot,
        unit: s.LotRoudingUnit
      }));
      return summarizeLotsGeneric(normalized);
    },
    quantities: (suggestions: Suggestion[]) => {
      const normalized = suggestions.map(s => ({
        quantity: s.Quantity,
        unit: s.MaterialUnitOfMeasure
      }));
      return summarizeQuantitiesGeneric(normalized);
    }
  }
};

/* -------------------------------
   Funções genéricas privadas
-------------------------------- */

function summarizeQuantitiesGeneric(items: { quantity: string | number; unit: string }[]) {
  return items.reduce<Record<string, string>>((acc, item) => {
    if (!item.unit) return acc;

    let qty: number =
      typeof item.quantity === "string"
        ? parseFloat(item.quantity.split(" ")[0].replace(",", ""))
        : item.quantity;

    if (isNaN(qty)) qty = 0;

    const total = (parseFloat(acc[item.unit] || "0") + qty).toFixed(3);
    acc[item.unit] = total;

    return acc;
  }, {});
}

function summarizeLotsGeneric(items: { lot: string | number; unit?: string }[]) {
  return items.reduce<Record<string, string>>((acc, item) => {
    if (typeof item.lot === "number") {
      const unit = item.unit ?? "UN";
      const total = (parseFloat(acc[unit] || "0") + item.lot).toFixed(3);
      acc[unit] = total;
    } else if (typeof item.lot === "string") {
      const [qtyStr, unit = "UN"] = item.lot.split(" ");
      const qty = parseFloat(qtyStr.replace(",", ""));
      if (!isNaN(qty)) {
        const total = (parseFloat(acc[unit] || "0") + qty).toFixed(3);
        acc[unit] = total;
      }
    }
    return acc;
  }, {});
}


